import Icon from "@/components/ui/icon";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

type Props = {
  src: string;
  closePopUp: () => void;
  popUpKey?: string;
};

export const LinkPopUp = ({ src, closePopUp, popUpKey }: Props) => {
  "use no memo";
  const [linkSrc, setLinkSrc] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!src || src.trim().length === 0) return closePopUp();

    if (src.startsWith("http://"))
      setLinkSrc(src.replace("http://", "https://"));
    else setLinkSrc(src.startsWith("https://") ? src : `https://${src}`);
    setIsLoading(true);
  }, [src]);

  if (!linkSrc) return null;

  return createPortal(
    <div className="tw-fixed tw-left-0 tw-top-0 tw-z-[99998] tw-flex tw-h-screen tw-w-screen tw-items-center tw-justify-center">
      <div className="tw-relative tw-z-10 tw-h-full tw-max-h-[880px] tw-w-full tw-max-w-[1440px] tw-px-16 tw-py-10 max-lg:tw-h-full max-lg:tw-max-h-none max-lg:tw-w-full max-lg:tw-min-w-0 max-lg:tw-self-end max-lg:tw-px-2 max-lg:tw-pb-2 max-lg:tw-pt-14">
        <button
          className="tw-absolute tw-right-2 tw-top-10 tw-size-10 tw-cursor-pointer tw-rounded-full tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-shadow-sm tw-transition-opacity hover:!tw-opacity-70 max-lg:tw-top-2"
          onClick={closePopUp}
        >
          <Icon
            icon="ri-close-line"
            className="tw-text-2xl/none tw-text-blue-500"
          />
        </button>
        <div className="tw-relative tw-size-full tw-overflow-hidden tw-rounded-lg tw-bg-white">
          <iframe
            title="Link Pop Up"
            src={linkSrc}
            className={classNames(
              "tw-absolute tw-inset-0 tw-z-1 tw-h-full tw-w-full tw-border-0",
              {
                "tw-opacity-0": isLoading,
              },
            )}
            onLoad={() => setIsLoading(false)}
          />
          {isLoading && (
            <div className="tw-absolute tw-left-1/2 tw-top-1/2 tw-z-10 tw-h-[50px] tw-w-[50px] -tw-translate-x-1/2 -tw-translate-y-1/2">
              <div className="tw-h-full tw-w-full tw-animate-spin-regular tw-rounded-full tw-border-4 tw-border-solid tw-border-primary-700 !tw-border-r-[transparent]" />
            </div>
          )}
        </div>
      </div>
      <div className="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-bg-[rgba(31,_31,_31,_0.4)]" />
    </div>,
    document.body,
    popUpKey,
  );
};
